import { ScrollGeometryWorkbench } from './scroll-geometry-workbench'

export default function DevPage() {
  return <ScrollGeometryWorkbench />
}
